<div class="filter-custom-field" *ngIf="customField">
  <div class="label-row">
    <label>{{ customField.label }}</label>
    <button 
      type="button" 
      class="btn btn-sm btn-outline-secondary clear-btn"
      (click)="clearValue()"
      *ngIf="currentValue"
      title="Clear filter"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- Operator Selection -->
  <div class="form-group mb-2">
    <select
      class="form-control operator-select"
      [(ngModel)]="currentOperator"
      (ngModelChange)="onOperatorChange($event)"
    >
      <option 
        *ngFor="let operator of availableOperators" 
        [value]="operator.value"
      >
        {{ operator.label }}
      </option>
    </select>
  </div>

  <!-- Value Input - only show if operator needs a value -->
  <div *ngIf="operatorNeedsValue(currentOperator)">
    <!-- String Input -->
    <div *ngIf="customField.type === eCustomFieldType.STRING" class="form-group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="currentValue"
        (ngModelChange)="onValueChange($event)"
        [placeholder]="getPlaceholder()"
      />
      <small 
        *ngIf="currentOperator === 'in' || currentOperator === 'notin'" 
        class="form-text text-muted"
      >
        Separate multiple values with commas
      </small>
    </div>

    <!-- Number Input -->
    <div *ngIf="customField.type === eCustomFieldType.NUMBER" class="form-group">
      <input
        type="number"
        class="form-control"
        [(ngModel)]="currentValue"
        (ngModelChange)="onValueChange($event)"
        [placeholder]="getPlaceholder()"
        step="any"
      />
      <small 
        *ngIf="currentOperator === 'in' || currentOperator === 'notin'" 
        class="form-text text-muted"
      >
        Separate multiple numbers with commas
      </small>
    </div>

    <!-- Date Input -->
    <div *ngIf="customField.type === eCustomFieldType.DATE" class="form-group">
      <input
        type="date"
        class="form-control"
        [(ngModel)]="currentValue"
        (ngModelChange)="onValueChange($event)"
      />
    </div>

    <!-- Dropdown Select -->
    <div *ngIf="customField.type === eCustomFieldType.DROPDOWN" class="form-group">
      <!-- Single selection for eq/neq -->
      <select
        *ngIf="currentOperator === 'eq' || currentOperator === 'neq'"
        class="form-control"
        [(ngModel)]="currentValue"
        (ngModelChange)="onValueChange($event)"
      >
        <option value="">-- Select {{ customField.label }} --</option>
        <option 
          *ngFor="let option of customField.options" 
          [value]="option"
        >
          {{ option }}
        </option>
      </select>

      <!-- Multi-selection for in/notin -->
      <div *ngIf="currentOperator === 'in' || currentOperator === 'notin'">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="currentValue"
          (ngModelChange)="onValueChange($event)"
          [placeholder]="'Select from: ' + (customField.options?.join(', ') || '')"
        />
        <small class="form-text text-muted">
          Available options: {{ customField.options?.join(', ') }}
          <br>Separate multiple selections with commas
        </small>
      </div>
    </div>
  </div>

  <!-- Info message for set/notset operators -->
  <div *ngIf="!operatorNeedsValue(currentOperator)" class="form-group">
    <small class="form-text text-info">
      <i class="fa fa-info-circle"></i>
      This filter will find products where {{ customField.label }} 
      {{ currentOperator === 'set' ? 'has any value' : 'is empty or not set' }}
    </small>
  </div>
</div> 